const profileImageFallback =
  'https://assets.cloud.pennylane.ai/profiles/fallback-avatar.png'

export const handleThumbnail = ({
  thumbnail,
  contentType,
}: {
  thumbnail: string
  contentType: string
}) => {
  if (thumbnail) {
    return thumbnail
  }

  if (contentType === 'PROFILE') {
    return profileImageFallback
  }

  return ''
}
